import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Button,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Nav,
    UncontrolledDropdown,
} from 'reactstrap';

import DefaultAvatar from '../../../assets/images/Qase-Default-Avatar.png';

import { logout } from '../../../redux/actions/authActions';
import { getAuth } from '../../../redux/selectors';
import { AbilityContext } from '../../../utility/context/Can';

const NavbarUser = () => {
    const { loggedUser } = useSelector(getAuth);
    const ability = useContext(AbilityContext);
    const dispatch = useDispatch();
    // const history = useHistory();
    const handleLogout = () => {
        dispatch(logout());
    };

    // const handleNavigation = (e, path) => {
    //     e.preventDefault();
    //     history.push(path);
    // };

    const [emailModal, setEmailModal] = useState(false);

    const toggleEmailModal = () => setEmailModal(!emailModal);
    return (
        <>
            <Nav className="ms-auto align-items-center" navbar>
                <UncontrolledDropdown className="dropdown-user" nav>
                    <DropdownToggle nav>
                        <img
                            src={
                                loggedUser?.userDetail?.profilePicture
                                    ? `${process.env.REACT_APP_API_URL}files?fileKey=${loggedUser?.userDetail?.profilePicture}`
                                    : DefaultAvatar
                            }
                            alt=""
                        />
                    </DropdownToggle>
                    <DropdownMenu end>
                        {/* <DropdownItem
                        tag="a"
                        target="_blank"
                        href="https://help.qase.ca/en/knowledge/view-referrals-lead-intake-instant-consult-booking"
                    >
                        Get Support
                    </DropdownItem> */}
                        <div
                            className="user-info"
                            //style={{ padding: 10, whiteSpace: 'nowrap' }}
                        >
                            <span>{`${loggedUser?.firstName || ''} ${
                                loggedUser?.lastName || ''
                            }`}</span>
                        </div>
                        <DropdownItem onClick={toggleEmailModal}>
                            Help
                        </DropdownItem>
                        {ability.can('read', 'profile') && (
                            <DropdownItem tag={Link} to="/profile">
                                Profile
                            </DropdownItem>
                        )}
                        <DropdownItem divider />
                        <DropdownItem tag="a" onClick={handleLogout}>
                            Logout
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </Nav>

            <Modal isOpen={emailModal} toggle={toggleEmailModal}>
                <ModalHeader
                    toggle={toggleEmailModal}
                    className="bg-primary text-white fw-bold"
                    tag="div"
                    close={
                        <button
                            className="btn-close btn-close-white"
                            onClick={toggleEmailModal}
                        ></button>
                    }
                >
                    Need help or have feedback?
                </ModalHeader>
                <ModalBody>
                    <p>
                        If you have any questions or feedback please let us
                        know! Our team at Qase would love to hear from you. Just
                        click below to send us an email, and we’ll get back to
                        you as soon as possible.
                    </p>
                </ModalBody>
                <ModalFooter className="border-0 justify-content-center">
                    <Button
                        color="link"
                        onClick={toggleEmailModal}
                        className="me-2 text-decoration-none"
                    >
                        Close
                    </Button>
                    <a
                        href="mailto:support@qase.ca?subject=Qase Support Request or Feedback"
                        className="btn btn-primary"
                    >
                        Email Support
                    </a>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default NavbarUser;
